<!-- Datetime mode: Date picker + Time picker -->
@if (mode === 'datetime') {
  <div class="datetime-picker-container" [matTooltip]="tooltipText">
    <mat-form-field appearance="outline" class="date-field" (click)="!disabled && picker.open()"
      [floatLabel]="dateFocused || dateText.length ? 'always' : 'auto'">
      @if (label) {
        <mat-label>{{ label }}</mat-label>
      }
      <input matInput #dateInput [matDatepicker]="picker" [value]="dateValue"
        [placeholder]="placeholder || 'MM/DD/YYYY'" [required]="required" [disabled]="disabled"
        (dateChange)="onDateChange($event)" (keydown)="onDateKeydown($event)"
        (input)="onDateInput($event); dateText = dateInput.value" (paste)="onDatePaste($event)"
        (focus)="dateFocused = true" (blur)="dateFocused = false; onDateInputBlur($event)" maxlength="10">
        <mat-datepicker-toggle matSuffix [for]="picker"
        (click)="onDatePickerToggle(); $event.stopPropagation()"></mat-datepicker-toggle>
        <mat-datepicker #picker (opened)="onDatePickerOpened()" (closed)="onDatePickerClosed()"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="time-field">
        <mat-label>Time</mat-label>
        <input matInput #timeInput
          [value]="displayTime || defaultTimeString"
          [placeholder]="defaultTimeString || 'h:mm AM'"
          [disabled]="disabled"
          (input)="onTimeTextInput($event)"
          (blur)="onTimeTextBlur(timeInput.value, timeInput)"
          (keydown.enter)="onTimeTextBlur(timeInput.value, timeInput); $event.preventDefault()">
        <button mat-icon-button matSuffix type="button"
          [disabled]="disabled"
          (click)="keypad.openPicker($event)"
          aria-label="Open time picker"
          data-testid="keypad-time-picker-trigger">
          <mat-icon>schedule</mat-icon>
        </button>
        <app-keypad-time-picker #keypad
          [initialTime]="displayTime || defaultTimeString"
          [defaultMeridiem]="referenceMeridiem"
          (timeSet)="onKeypadTimeSet($event, timeInput)"
          (cleared)="clearTime(timeInput)">
        </app-keypad-time-picker>
      </mat-form-field>
      </div>
    }

    <!-- Date-only mode: Just the date picker -->
    @if (mode === 'date') {
      <mat-form-field appearance="outline" class="w-100" (click)="!disabled && datePicker.open()"
        [matTooltip]="tooltipText">
        @if (label) {
          <mat-label>{{ label }}</mat-label>
        }
        @if (prefixIcon) {
          <mat-icon matPrefix>{{ prefixIcon }}</mat-icon>
        }
        <input matInput [matDatepicker]="datePicker" [value]="dateValue" [placeholder]="placeholder || 'MM/DD/YYYY'"
          [required]="required" [disabled]="disabled" (dateChange)="onDateOnlyChange($event)"
          (keydown)="onDateKeydown($event)" (input)="onDateInput($event)" (paste)="onDatePaste($event)"
          (blur)="onDateInputBlur($event)" maxlength="10">
          <mat-datepicker-toggle matSuffix [for]="datePicker" (click)="$event.stopPropagation()"></mat-datepicker-toggle>
          <mat-datepicker #datePicker></mat-datepicker>
          @if (hint) {
            <mat-hint>{{ hint }}</mat-hint>
          }
        </mat-form-field>
      }

      <!-- Time-only mode: Just the time input -->
      @if (mode === 'time') {
        <mat-form-field appearance="outline" class="w-100" [matTooltip]="tooltipText">
          @if (label) {
            <mat-label>{{ label }}</mat-label>
          }
          @if (prefixIcon) {
            <mat-icon matPrefix>{{ prefixIcon }}</mat-icon>
          }
          <input matInput type="time" [value]="timeValue" [placeholder]="placeholder" [required]="required"
            [disabled]="disabled" (input)="onTimeOnlyChange($event)" (blur)="onBlur()">
            @if (hint) {
              <mat-hint>{{ hint }}</mat-hint>
            }
          </mat-form-field>
        }
